const PING_INTERVAL = 15000

// Слаг для прямого ефіру. Бекенд рахує сесії за слагом аніме, тож стріму
// вистачає власного зарезервованого імені: лічильник глядачів виходить
// сам собою, і ці сесії автоматично потрапляють у загальний онлайн
export const LIVE_PRESENCE_SLUG = '__live__'

// slugOverride — для сторінок, де слаг не береться з адреси (/live)
export const useOnlinePresence = (slugOverride = null) => {
  const stats = useState('onlinePresenceStats', () => ({
    global: 0,
    anime: null,
    episode: null,
    episodes: null
  }))

  if (import.meta.client) {
    const config = useRuntimeConfig()
    const route = useRoute()
    const currentEpisode = useState('watchCurrentEpisode', () => null)

    let sessionId = sessionStorage.getItem('onlineSessionId')
    if (!sessionId) {
      sessionId = crypto.randomUUID()
      sessionStorage.setItem('onlineSessionId', sessionId)
    }

    // Фонова вкладка онлайном не рахується: пінги з неї не йдуть, і за TTL
    // на бекенді сесія сама випадає з лічильника
    const isHidden = () => document.visibilityState === 'hidden'

    const send = async () => {
      if (isHidden()) return

      const animeSlug =
        slugOverride ||
        (typeof route.params.name === 'string' ? route.params.name : null)
      // У стріму серій немає — епізод лишається порожнім
      const episodeIndex =
        animeSlug && !slugOverride ? currentEpisode.value : null

      try {
        const res = await $fetch(`${config.public.apiBase}/api/online/ping`, {
          method: 'POST',
          body: {
            sessionId,
            anime: animeSlug,
            episode: episodeIndex
          }
        })
        stats.value = res
      } catch (e) {
        // Мовчки ігноруємо мережеві збої - лічильник не критичний функціонал
      }
    }

    let timer = null

    const startPinging = () => {
      if (timer) return
      timer = setInterval(send, PING_INTERVAL)
    }

    const stopPinging = () => {
      if (!timer) return
      clearInterval(timer)
      timer = null
    }

    const handleVisibility = () => {
      if (isHidden()) {
        stopPinging()
        return
      }

      // Повернулись на вкладку — не чекаємо наступного тика, щоб і лічильник
      // оновився одразу, і сесія не встигла протухнути
      send()
      startPinging()
    }

    onMounted(() => {
      handleVisibility()
      document.addEventListener('visibilitychange', handleVisibility)
    })

    onUnmounted(() => {
      stopPinging()
      document.removeEventListener('visibilitychange', handleVisibility)
    })

    watch(() => [route.params.name, currentEpisode.value], send)
  }

  return stats
}
